module.exports = __webpack_public_path__ + "assets/img/e5d933ea68759ee85a8785fae69d390c.svg";